import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { QrCode, PuzzlePiece } from '@phosphor-icons/react';

import styles from './qr-nonogram-promo.module.scss';

interface QrNonogramPromoProps {
  variant?: 'card' | 'accent';
}

const QrNonogramPromo: FC<QrNonogramPromoProps> = ({ variant = 'accent' }) => {
  const { t } = useTranslation();

  return (
    <section className={styles.announcement}>
      <div className={styles.announcementContent}>
        <div className={styles.announcementIcon}>
          <QrCode size={32} weight="fill" />
          <PuzzlePiece size={18} weight="fill" className={styles.iconPuzzle} />
        </div>
        <div className={styles.announcementText}>
          <span className={styles.announcementBadge}>{t('clientAll.qrNonogramPromo.badge')}</span>
          <h3 className={styles.announcementTitle}>{t('clientAll.qrNonogramPromo.title')}</h3>
          <p className={styles.announcementDesc}>
            {t('clientAll.qrNonogramPromo.description')}
          </p>
        </div>
        <a
          href="https://gameinvitation.com/qr-nonogram-generator?utm_source=constructor&utm_medium=promo&utm_campaign=qr-nonogram&utm_content=qr-section"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.announcementBtn}
        >
          {t('clientAll.qrNonogramPromo.cta')}
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 256 256"><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"/></svg>
        </a>
      </div>
    </section>
  );
};

export default QrNonogramPromo;